import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';

import type { EditingContext } from '../edit-context.gts';

export type Focus = 'default' | 'question';
export type View = 'input' | 'output';

function eq(a: string, b: string): boolean {
  return a === b;
}

export const QuizEditMode: TemplateOnlyComponent<{
  Args: {
    view: View;
    setView: (view: View) => void;
    context: EditingContext;
  };
}> = <template>
  <div class="bg-white px-4 py-3 border">
    <nav class="nav nav-pills flex-column flex-sm-row">
      <button
        type="button"
        class="flex-sm-fill text-sm-center nav-link fw-bold
          {{if (eq @view 'input') 'active'}}"
        disabled={{@context.isEditing}}
        {{on "click" (fn @setView "input")}}
      >Input Form</button>
      <button
        type="button"
        class="flex-sm-fill text-sm-center nav-link fw-bold
          {{if (eq @view 'output') 'active'}}"
        disabled={{@context.isEditing}}
        {{on "click" (fn @setView "output")}}
      >Results Display</button>
    </nav>
  </div>
</template>;
